// Where pdf.js 6 loads its on-demand assets from (copied into public/pdfjs by
// scripts/copy-pdfjs-assets.mjs). Pass to every getDocument() call: without
// them JBIG2 / JPEG 2000 images, colour profiles and non-embedded standard
// fonts don't render correctly.
export const PDFJS_ASSET_OPTIONS = {
  wasmUrl: '/pdfjs/wasm/',
  standardFontDataUrl: '/pdfjs/standard_fonts/',
  iccUrl: '/pdfjs/iccs/',
  cMapUrl: '/pdfjs/cmaps/',
  cMapPacked: true,
} as const
